import { bem } from '@socialive/common';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { forwardRef, useMemo } from 'react';
import './dateInput.css';

/*
#tailwind
dateInput dateInput--outlined dateInput--filled dateInput--subtle dateInput--success dateInput--error
dateInput--warning dateInput--default dateInput--disabled
*/

const DateInput = forwardRef(
  (
    { className, context, disabled, maxDate, minDate, mode, name, onBlur, onChange, placeholder, value, ...other },
    ref
  ) => {
    const min = useMemo(() => {
      try {
        return format(new Date(minDate), 'yyyy-MM-dd');
      } catch {
        return undefined;
      }
    }, [minDate]);

    const max = useMemo(() => {
      try {
        return format(new Date(maxDate), 'yyyy-MM-dd');
      } catch {
        return undefined;
      }
    }, [maxDate]);

    return (
      <input
        className={bem`dateInput--${{
          [context]: true,
          disabled,
          [mode]: true,
        }} ${className}`}
        type="date"
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        ref={ref}
        {...other}
        min={min}
        max={max}
      />
    );
  }
);

DateInput.propTypes = {
  className: PropTypes.string,
  context: PropTypes.oneOf(['success', 'error', 'warning', 'default']),
  disabled: PropTypes.bool,
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  mode: PropTypes.oneOf(['filled', 'outlined', 'subtle']),
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

DateInput.defaultProps = {
  className: undefined,
  context: 'default',
  disabled: false,
  maxDate: undefined,
  minDate: undefined,
  mode: 'filled',
  name: undefined,
  onBlur: undefined,
  onChange: undefined,
  placeholder: undefined,
  value: undefined,
};

export default DateInput;
